import { EInputFieldType } from '@app/core/enum/input-field.enum'

export type TInputFieldValue = string | number | Date | null

export { EInputFieldType }

/** Restricts characters for `EInputFieldType.Text` (typing + paste). */
export type TInputFieldTextFilter =
    | 'lettersOnly'
    | 'namePart'
    | 'digitsOnly'
    | 'section'
    | 'alphanumericOnly'

export interface IInputFieldOption {
    readonly label: string
    readonly value: string
}

export interface IInputFieldConfig {
    readonly label: string
    readonly placeholder?: string
    readonly required?: boolean
    readonly type: EInputFieldType
    readonly options?: readonly IInputFieldOption[]
    readonly countryOptions?: readonly IInputFieldOption[]
    readonly allowCreateNew?: boolean
    readonly minDate?: Date
    readonly maxDate?: Date
    /** For type Number: e.g. '0.01' to allow at most 2 decimal places */
    readonly step?: string
    /** When type is Text: restrict input to allowed character class */
    readonly textFilter?: TInputFieldTextFilter
    /**
     * When true with type Number: render as text + numeric inputmode (discount %-style) so
     * browsers never accept `-`, `+`, or scientific notation in the field.
     */
    readonly restrictToPositiveIntegerDigits?: boolean
    /** When set with restrictToPositiveIntegerDigits, blocks extra digit keypresses and truncates paste. */
    readonly maxDigits?: number
    /** Maximum character length for Text and Email inputs (enforced on type/paste and via HTML maxlength). */
    readonly maxLength?: number
    /**
     * When true with type Text: block digits and symbols at keydown/paste (contact book names).
     */
    readonly restrictToContactPersonName?: boolean
}
